import { render, staticRenderFns } from "./stocklist.vue?vue&type=template&id=0674a9e2&"
import script from "./stocklist.vue?vue&type=script&lang=js&"
export * from "./stocklist.vue?vue&type=script&lang=js&"
import style0 from "./stocklist.vue?vue&type=style&index=0&id=0674a9e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports